import axios from 'axios';

export default {
  namespaced: true,
  state: {
    regions: []
  },
  mutations: {
    getRegions(state, allRegions) {
      state.regions = allRegions;
    }
  },
  actions: {
    getRegions({ commit }) {
      return new Promise(resolve => {
        axios.get('/Region/').then(response => {
          commit('getRegions', response.data);
          resolve(response);
        });
      });
    }
  }
};
